@import (reference) '../../../../app-brand/entities/entity-layer.module.less';

.field {
  width: 100%;
}

.field-label {
  color: var(--grey-900);
}

.field-label-with-button {
  justify-content: space-between;
  align-items: center;
}

.validation-error {
  color: var(--red-800);
}
